export default function Container({ children, className = "", style }) {
  return (
    <div
      className={`site-container${className ? ` ${className}` : ""}`}
      style={style}
    >
      {children}
    </div>
  );
}
